export default "__VITE_ASSET__ClsgrA7k__"